export default class ProductTabs {
  constructor() {
    this.element = {
      templateTitle: document.querySelector('.template__title') ? document.querySelector('.template__title').innerHTML : false,
      templateUrl: document.querySelector('.breadcrumbs') ? document.querySelector('.breadcrumbs').dataset.templateUrl : false,
      productTitle: document.querySelector('.product__title') ? document.querySelector('.product__title').innerHTML : false,
    };
  }

  clearStoredCrumbs(storedTitle, storedUrl) {
    sessionStorage.removeItem(storedTitle);
    sessionStorage.removeItem(storedUrl);
  }

  addBreadcrumb(storedTitle, storedUrl, bcTitle, bcUrl) {
    bcTitle = sessionStorage.getItem(storedTitle);
    bcUrl = sessionStorage.getItem(storedUrl);

    if (bcTitle && bcUrl) {
      // Temp fix to remove the 'plp-' prefix from demo urls
      bcUrl = bcUrl.replace('collections/plp-', 'collections/');

      // Gets the last sep span that proceeds the product title
      let lastSep = Array.from(document.querySelectorAll('.breadcrumbs .sep')).pop();

      let bcSepSpan = document.createElement('span');
      bcSepSpan.setAttribute('class', 'sep p6');
      bcSepSpan.setAttribute('aria-hidden', 'true');
      bcSepSpan.innerHTML = '/';
      let bcTitleSpan = document.createElement('span');
      bcTitleSpan.setAttribute('class', 'plp__title');
      bcTitleSpan.innerHTML = `<a href="${bcUrl}" class="link p6" title='${bcTitle}'>${bcTitle}</a>`;

      let breadcrumb = lastSep.parentNode;
      breadcrumb.insertBefore(bcTitleSpan, lastSep);
      breadcrumb.insertBefore(bcSepSpan, bcTitleSpan);
    }
  }

  clickEvent() {
    document.addEventListener('click', (e) => {
      const siteHeader = e.target.closest('.site-header');
      const siteFooter = e.target.closest('.site-footer');
      if (siteHeader || siteFooter) {
        this.clearStoredCrumbs('_bc_slp_title', '_bc_slp_url');
        this.clearStoredCrumbs('_bc_title', '_bc_url');
      }
    });
  }

  setStorageItems(bcTitle) {
    // Store title and url for PLP only if not embedded on another page
    if (this.element.templateTitle && !sessionStorage.getItem('_bc_title')) {
      sessionStorage.setItem('_bc_title', this.element.templateTitle);
      sessionStorage.setItem('_bc_url', this.element.templateUrl);
    }
  }

  setUpBreadCrumbs() {
    let bcTitle = sessionStorage.getItem('_bc_title');
    let bcUrl = sessionStorage.getItem('_bc_url');

    if (this.element.productTitle) {
      this.addBreadcrumb('_bc_slp_title', '_bc_slp_url', bcTitle, bcUrl);
      this.addBreadcrumb('_bc_title', '_bc_url');
      this.clearStoredCrumbs('_bc_title', '_bc_url');
    }

    if (this.element.templateTitle) {
      this.addBreadcrumb('_bc_slp_title', '_bc_slp_url', bcTitle, bcUrl);
    }
  }

  init() {
    this.setStorageItems();

    // Clear stored SLP cookies when the site header is clicked
    this.clickEvent();

    this.setUpBreadCrumbs();
  }
}
